import React, { useEffect, useMemo, useState } from 'react';
import {
  Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, MenuItem, Paper, Switch, TextField, Typography
} from '@mui/material';
import { apiFetch } from '../services/api';

export const PUSTY_SRODEK = {
  id_indeksu: '',
  id_kategorii: '',
  id_producenta: '',
  id_lokalizacji: '',
  id_pracownika: '',
  id_firmy_serwisowej: '',
  model: '',
  numer_inw: '',
  numer_seryjny: '',
  numer_unikatowy: '',
  status: 'NOWY',
  oprogramowanie: '',
  komentarz: '',
  data_produkcji: '',
  data_zakupu: '',
  data_przyjecia: '',
  data_gwarancji_do: '',
  numer_zamowienia: '',
  notatka_ewidencja: '',
  notatka_parametry: ''
};

const PUSTE_PARAMETRY = [];

const STATUSY = [
  ['NOWY', 'Nowy'], ['AKTYWNY', 'Aktywny'], ['MAGAZYN', 'Magazyn'], ['W_SERWISIE', 'W serwisie'],
  ['USZKODZONY', 'Uszkodzony'], ['WYCOFANY', 'Wycofany'], ['SPRZEDANY', 'Sprzedany'], ['ZLIKWIDOWANY', 'Zlikwidowany']
];

const dataInput = v => v ? String(v).slice(0, 10) : '';
const dataPL = v => {
  const iso=dataInput(v);
  if(!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso||'—';
  const [r,m,d]=iso.split('-');
  return `${d}.${m}.${r}`;
};
const pierwszyDzienNastepnegoMiesiaca = v => {
  const iso=dataInput(v);
  if(!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return '';
  const [r,m]=iso.split('-').map(Number);
  const d=new Date(Date.UTC(r,m,1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth()+1).padStart(2,'0')}-01`;
};

// Wartości domyślne, gdy słownik jest pusty

const OPCJE_DOMYSLNE = {
  PROCESOR: ['Intel Core i3', 'Intel Core i5', 'Intel Core i7', 'Intel Core i9', 'AMD Ryzen 3', 'AMD Ryzen 5', 'AMD Ryzen 7', 'AMD Ryzen 9', 'Intel Xeon', 'AMD EPYC'],
  RAM: ['4', '8', '16', '32', '64', '128', '256', '512'],
  DYSK: ['256 GB SSD', '512 GB SSD', '1 TB SSD', '2 TB SSD', '256 GB NVMe', '512 GB NVMe', '1 TB NVMe', '2 TB NVMe', '1 TB HDD', '2 TB HDD', '4 TB HDD', '8 TB HDD'],
  SYSTEM: ['Windows 10', 'Windows 10 Pro', 'Windows 11', 'Windows 11 Pro', 'Windows Server 2019', 'Windows Server 2022', 'Windows Server 2025', 'Linux', 'macOS'],
  EKRAN: ['13.3', '14', '15.6', '16', '17.3', '21.5', '23.8', '24', '27', '32', '34'],
  ROZDZIELCZOSC: ['1366x768', '1920x1080', '1920x1200', '2560x1440', '2560x1600', '3440x1440', '3840x2160'],
  ODSWIEZANIE: ['60', '75', '100', '120', '144', '165', '180', '240'],
  LICZBA_PORTOW: ['4', '5', '8', '12', '16', '24', '48'],
  PREDKOSC: ['100 Mb/s', '1 Gb/s', '2.5 Gb/s', '5 Gb/s', '10 Gb/s', '25 Gb/s', '40 Gb/s', '100 Gb/s'],
  INTERFEJS: ['USB', 'USB-C', 'SATA', 'SAS', 'NVMe', 'Ethernet', 'Wi-Fi', 'Bluetooth', 'HDMI', 'DisplayPort', 'VGA'],
  RAID: ['Brak', 'RAID 0', 'RAID 1', 'RAID 5', 'RAID 6', 'RAID 10'],
  TYP_MATRYCY: ['IPS', 'VA', 'TN', 'OLED', 'Mini LED'],
  ZLACZA: ['HDMI', 'DisplayPort', 'USB-C', 'VGA', 'DVI'],
  FORMAT: ['A4', 'A3', 'A4/A3'],
  TAK_NIE: ['Tak', 'Nie'],
  TYP_URZADZENIA_SIEC: ['Switch', 'Router', 'Access Point', 'Modem', 'Gateway', 'Firewall'],
  TYP_PAMIECI: ['HDD', 'SSD', 'NVMe', 'NAS', 'SAN', 'Macierz dyskowa'],
  TYP_BATERII: ['VRLA/AGM', 'Żelowa', 'Li-Ion', 'LiFePO4'],
  LICZBA_KANALOW: ['4', '8', '16', '32', '64']
};

export function mapujSrodekDoFormularza(s) {
  return {
    ...PUSTY_SRODEK,
    ...s,
    id_indeksu: s.id_indeksu ?? '',
    id_kategorii: s.id_kategorii ?? '',
    id_producenta: s.id_producenta ?? '',
    id_lokalizacji: s.id_lokalizacji ?? '',
    id_pracownika: s.id_pracownika ?? '',
    id_firmy_serwisowej: s.id_firmy_serwisowej ?? '',
    model: s.model ?? '',
    data_produkcji: dataInput(s.data_produkcji),
    data_zakupu: dataInput(s.data_zakupu),
    data_przyjecia: dataInput(s.data_przyjecia),
    data_gwarancji_do: dataInput(s.data_gwarancji_do),
    notatka_ewidencja: s.notatka_ewidencja || '',
    notatka_parametry: s.notatka_parametry || ''
  };
}

export default function FormularzSrodka({
  wartosciPoczatkowe = PUSTY_SRODEK,
  parametryPoczatkowe = PUSTE_PARAMETRY,
  amortyzacjaPoczatkowa = { enabled: false },
  tryb = 'dodaj',
  onZapisz,
  onAnuluj
}) {
  const [form, setForm] = useState(() => mapujSrodekDoFormularza(wartosciPoczatkowe));
  const [slowniki, setSlowniki] = useState({ kategorie: [], producenci: [], lokalizacje: [], pracownicy: [], serwisy: [], metody: [] });
  const [definicje, setDefinicje] = useState([]);
  const [parametry, setParametry] = useState({});
  const [wlasneParametry, setWlasneParametry] = useState({});
  const [amortyzacja, setAmortyzacja] = useState(amortyzacjaPoczatkowa || { enabled: false });
  const [blad, setBlad] = useState('');
  const [zapisuje, setZapisuje] = useState(false);
  const [bladDialogOpen, setBladDialogOpen] = useState(false);
  const [pokazNotatkeInformacje, setPokazNotatkeInformacje] = useState(() => !!wartosciPoczatkowe?.komentarz);
  const [pokazNotatkeEwidencja, setPokazNotatkeEwidencja] = useState(() => !!wartosciPoczatkowe?.notatka_ewidencja);
  const [pokazNotatkeParametry, setPokazNotatkeParametry] = useState(() => !!wartosciPoczatkowe?.notatka_parametry);
  const [krok, setKrok] = useState(1);

  useEffect(() => {
    setForm(mapujSrodekDoFormularza(wartosciPoczatkowe));
    setWlasneParametry({});
  }, [wartosciPoczatkowe]);

  useEffect(() => {

    const mapa = {};
    for (const p of parametryPoczatkowe || PUSTE_PARAMETRY) {
      if (p.typ_danych === 'NUMBER') mapa[p.id_parametru] = p.wartosc_liczba ?? '';
      else if (p.typ_danych === 'DATE') mapa[p.id_parametru] = p.wartosc_data ? String(p.wartosc_data).slice(0, 10) : '';
      else if (p.typ_danych === 'BOOLEAN') mapa[p.id_parametru] = !!p.wartosc_bool;
      else mapa[p.id_parametru] = p.wartosc_tekst ?? '';
    }
    setParametry(mapa);
  }, [parametryPoczatkowe]);

  useEffect(() => {
    Promise.all([
      apiFetch('/slowniki/kategorie'),
      apiFetch('/slowniki/producenci'),
      apiFetch('/slowniki/lokalizacje'),
      apiFetch('/slowniki/pracownicy'),
      apiFetch('/slowniki/firmy-serwisowe'),
      apiFetch('/slowniki/metody-amortyzacji')
    ])
      .then(([kategorie, producenci, lokalizacje, pracownicy, serwisy, metody]) => {
        setSlowniki({ kategorie, producenci, lokalizacje, pracownicy, serwisy, metody });
      })
      .catch(e => setBlad(e.message));
  }, []);

  useEffect(() => {
    if (!form.id_kategorii) {
      setDefinicje([]);
      return;
    }
    apiFetch(`/slowniki/parametry/${form.id_kategorii}`)
      .then(setDefinicje)
      .catch(e => setBlad(e.message));
  }, [form.id_kategorii]);

  const wybranaKategoria = useMemo(
    () => slowniki.kategorie.find(x => String(x.id_kategorii) === String(form.id_kategorii)),
    [slowniki.kategorie, form.id_kategorii]
  );

  const zmien = pole => e => setForm(f => ({ ...f, [pole]: e.target.value }));
  const num = v => v === '' ? null : Number(v);

  const metodyAmortyzacji = useMemo(() => {
    const kolejnosc = { LINIOWA: 1, DEGRESYWNA: 2, JEDNORAZOWA: 3 };
    return [...(slowniki.metody || [])].sort((a,b) => {
      const ka=String(a.kod||a.nazwa||'').toUpperCase();
      const kb=String(b.kod||b.nazwa||'').toUpperCase();
      return (kolejnosc[ka]||99)-(kolejnosc[kb]||99);
    });
  }, [slowniki.metody]);
  const wybranaMetodaAmortyzacji = metodyAmortyzacji.find(x => String(x.id_metody) === String(amortyzacja?.id_metody));
  const nazwaMetodyAmortyzacji = String(wybranaMetodaAmortyzacji?.nazwa || '').toLowerCase();
  const metodaJednorazowa = nazwaMetodyAmortyzacji.includes('jednoraz');
  const metodaDegresywna = nazwaMetodyAmortyzacji.includes('degres');
  const opisMetodyAmortyzacji = nazwa => {
    const n=String(nazwa||'').toLowerCase();
    if(n.includes('liniow')) return {opis:'Stała kwota odpisu w kolejnych miesiącach.',wzor:'Odpis roczny = wartość początkowa × stawka; miesięczny = odpis roczny / 12'};
    if(n.includes('degres')) return {opis:'Wyższe odpisy na początku, później malejące wraz z wartością środka.',wzor:'Odpis roczny = wartość netto × stawka × współczynnik'};
    if(n.includes('jednoraz')) return {opis:'Cała wartość jest odpisywana jednorazowo po spełnieniu odpowiednich warunków.',wzor:'Odpis = wartość początkowa'};
    return {opis:'Wybierz metodę amortyzacji dla środka.',wzor:''};
  };
  const sugerowanaStawkaAmortyzacji = 30;
  const minimalnaDataAmortyzacji = useMemo(() => {
    const daty=[dataInput(form.data_zakupu),dataInput(form.data_przyjecia)].filter(Boolean).sort();
    return daty.length?daty[daty.length-1]:'';
  },[form.data_zakupu,form.data_przyjecia]);

  const wyliczDateWprowadzeniaAmortyzacji = () => minimalnaDataAmortyzacji;
  const sugerowanyPierwszyOdpisAmortyzacji = pierwszyDzienNastepnegoMiesiaca(
    minimalnaDataAmortyzacji || amortyzacja.data_wprowadzenia || amortyzacja.data_rozpoczecia
  );

  const zmienKategorie = e => {
    const v = e.target.value;
    setForm(f => ({ ...f, id_kategorii: v, id_indeksu: '' }));
    setParametry({});
    setWlasneParametry({});
  };

  function pobierzKluczOpcji(d) {
    const tekst = `${d.kod || ''} ${d.nazwa || ''}`.toUpperCase();

    if ((tekst.includes('LICZBA') || tekst.includes('ILOŚĆ') || tekst.includes('ILOSC')) && (tekst.includes('PROCESOR') || tekst.includes('CPU'))) return null;
    if (tekst.includes('PROCESOR') || tekst.includes('CPU')) return 'PROCESOR';
    if (tekst.includes('RAM') || tekst.includes('PAMIĘĆ RAM') || tekst.includes('PAMIEC RAM')) return 'RAM';
    if (tekst.includes('DYSK') || tekst.includes('SSD') || tekst.includes('HDD') || tekst.includes('PAMIĘĆ MASOWA') || tekst.includes('PAMIEC MASOWA')) return 'DYSK';
    if (tekst.includes('SYSTEM') || tekst.includes('OPERACYJ')) return 'SYSTEM';
    if (tekst.includes('PRZEKĄT') || tekst.includes('PRZEKAT') || tekst.includes('EKRAN')) return 'EKRAN';
    if (tekst.includes('ROZDZIEL')) return 'ROZDZIELCZOSC';
    if (tekst.includes('ODŚWIE') || tekst.includes('ODSWIE')) return 'ODSWIEZANIE';
    if (tekst.includes('LICZBA PORT')) return 'LICZBA_PORTOW';
    if (tekst.includes('PRĘDK') || tekst.includes('PREDK') || tekst.includes('TRANSMIS')) return 'PREDKOSC';
    if (tekst.includes('INTERFEJS')) return 'INTERFEJS';
    if (tekst.includes('RAID')) return 'RAID';
    if (tekst.includes('MATRYC')) return 'TYP_MATRYCY';
    if (tekst.includes('ZŁĄCZ') || tekst.includes('ZLACZ')) return 'ZLACZA';
    if (tekst.includes('FORMAT')) return 'FORMAT';
    if (tekst.includes('DUPLEX') || tekst.includes('ADF') || tekst.includes('POE')) return 'TAK_NIE';
    if (tekst.includes('TYP URZĄDZENIA') || tekst.includes('TYP URZADZENIA')) {
      const kat = String(wybranaKategoria?.nazwa || '').toUpperCase();
      if (kat.includes('TRANSMISJI') || kat.includes('OCHRONY DANYCH')) return 'TYP_URZADZENIA_SIEC';
      return null;
    }
    if (tekst.includes('TYP PAMIĘCI') || tekst.includes('TYP PAMIECI')) return 'TYP_PAMIECI';
    if (tekst.includes('TYP BATERII')) return 'TYP_BATERII';
    if (tekst.includes('LICZBA KANAŁ') || tekst.includes('LICZBA KANAL')) return 'LICZBA_KANALOW';

    return null;
  }

  function pobierzOpcje(d) {
    if (Array.isArray(d.opcje) && d.opcje.length) return d.opcje;
    const klucz = pobierzKluczOpcji(d);
    let wartosci = klucz ? OPCJE_DOMYSLNE[klucz] : [];
    if (d.typ_danych === 'NUMBER') {
      wartosci = wartosci.filter(v => String(v).trim() !== '' && Number.isFinite(Number(v)));
    }
    return wartosci.map((wartosc, i) => ({ id_opcji: `fallback-${klucz}-${i}`, wartosc }));
  }

  const wartoscParametruDoZapisu = d => {
    const v = parametry[d.id_parametru];
    if (v === undefined || v === null) return '';
    return v;
  };

  const zbudujParametry = () => definicje.map(d => {
    const v = wartoscParametruDoZapisu(d);
    const p = { id_parametru: d.id_parametru, wartosc_tekst: null, wartosc_liczba: null, wartosc_data: null, wartosc_bool: null };
    if (v === undefined || v === '') return p;
    if (d.typ_danych === 'NUMBER') p.wartosc_liczba = Number(v);
    else if (d.typ_danych === 'DATE') p.wartosc_data = v;
    else if (d.typ_danych === 'BOOLEAN') p.wartosc_bool = v ? 1 : 0;
    else p.wartosc_tekst = String(v);
    return p;
  });

  const enterDoKolejnegoPola = e => {
    if (e.key !== 'Enter' || e.shiftKey || e.target.tagName === 'TEXTAREA') return;
    e.preventDefault();
    const formEl = e.currentTarget;
    const pola = Array.from(formEl.querySelectorAll('input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])'))
      .filter(el => el.offsetParent !== null && !el.readOnly);
    const i = pola.indexOf(e.target);
    if (i >= 0 && i < pola.length - 1) pola[i + 1].focus();
  };

  const submit = async e => {
    e?.preventDefault?.();
    setBlad('');

    // Zapis jest dostępny na etapie podsumowania.
    
    if (krok !== 5) {
      if (!walidujKrok(krok)) return;
      setKrok(5);
      return;
    }

    setZapisuje(true);
    try {
      // Walidacja przed zapisem
      for (let n=1;n<=4;n+=1) {
        if (!walidujKrok(n)) {
          setZapisuje(false);
          return;
        }
      }

      const payload = {
        ...form,
        id_indeksu: form.id_indeksu ? Number(form.id_indeksu) : null,
        id_kategorii: Number(form.id_kategorii),
        id_producenta: num(form.id_producenta),
        model: form.model.trim(),
        id_lokalizacji: num(form.id_lokalizacji),
        id_pracownika: num(form.id_pracownika),
        id_firmy_serwisowej: num(form.id_firmy_serwisowej),
        komentarz: pokazNotatkeInformacje ? (form.komentarz || null) : null,
        notatka_ewidencja: pokazNotatkeEwidencja ? (form.notatka_ewidencja || null) : null,
        notatka_parametry: pokazNotatkeParametry ? (form.notatka_parametry || null) : null,
        parametry: zbudujParametry(),
        amortyzacja: amortyzacja?.enabled ? {
          enabled: true,
          id_metody: Number(amortyzacja.id_metody),
          wartosc_poczatkowa: Number(amortyzacja.wartosc_poczatkowa),
          stawka_roczna_proc: amortyzacja.stawka_roczna_proc === '' ? null : Number(amortyzacja.stawka_roczna_proc),
          data_wprowadzenia: amortyzacja.data_wprowadzenia || amortyzacja.data_rozpoczecia,
          data_rozpoczecia: amortyzacja.data_rozpoczecia || null,
          data_zakonczenia: amortyzacja.data_zakonczenia || null,
          status: amortyzacja.status || 'PLANOWANA',
          uwagi: amortyzacja.uwagi || null
        } : { enabled: false }
      };
      await onZapisz(payload);
    } catch (e) {
      setBlad(e.message);
      setBladDialogOpen(true);
    } finally {
      setZapisuje(false);
    }
  };

  const renderParametr = d => {
    const value = parametry[d.id_parametru] ?? '';
    const opcje = pobierzOpcje(d);

    if (d.typ_danych === 'BOOLEAN') {
      return <FormControlLabel key={d.id_parametru} control={
        <Switch checked={!!value} onChange={e => setParametry(p => ({ ...p, [d.id_parametru]: e.target.checked }))} />
      } label={`${d.nazwa}${d.wymagany ? ' *' : ''}`} />;
    }

    if (opcje.length) {
      const opcjeTekstowe = [...new Set(opcje.map(o => String(o.wartosc)))];
      const valueText = value === undefined || value === null ? '' : String(value);

      // Własna wartość parametru
      
      const wartoscSpozaListy = !!valueText && !opcjeTekstowe.includes(valueText);
      const trybWlasny = !!wlasneParametry[d.id_parametru] || wartoscSpozaListy;

      const wybierzOpcje = e => {
        const wybrana = e.target.value;

        if (wybrana === '__INNA__') {
          setWlasneParametry(w => ({ ...w, [d.id_parametru]: true }));
          setParametry(p => ({ ...p, [d.id_parametru]: '' }));
          return;
        }

        setWlasneParametry(w => ({ ...w, [d.id_parametru]: false }));
        setParametry(p => ({ ...p, [d.id_parametru]: wybrana }));
      };

      const wpiszWlasnaWartosc = e => {
        const nowaWartosc = e.target.value;
        setWlasneParametry(w => ({ ...w, [d.id_parametru]: true }));
        setParametry(p => ({ ...p, [d.id_parametru]: nowaWartosc }));
      };

      return <Box key={d.id_parametru}>
        <Typography variant="body2" fontWeight={600} sx={{mb:0.5}}>
          {d.nazwa}{d.jednostka ? ` (${d.jednostka})` : ''}{d.wymagany ? ' *' : ''}
        </Typography>

        <select
          value={trybWlasny ? '__INNA__' : valueText}
          required={!!d.wymagany && !trybWlasny}
          onChange={wybierzOpcje}
          style={{
            width:'100%', minHeight:'54px', padding:'0 12px', border:'1px solid #bdbdbd',
            borderRadius:'4px', background:'#fff', fontSize:'16px'
          }}
        >
          <option value="">-- wybierz --</option>
          {opcjeTekstowe.map(o => <option key={o} value={o}>{o}</option>)}
          <option value="__INNA__">Inna wartość — wpisz ręcznie</option>
        </select>

        {trybWlasny && <TextField
          fullWidth
          sx={{mt:1}}
          required={!!d.wymagany}
          label={`Własna wartość: ${d.nazwa}`}
          type={d.typ_danych === 'NUMBER' ? 'number' : 'text'}
          value={valueText}
          onChange={wpiszWlasnaWartosc}
          placeholder={d.typ_danych === 'NUMBER' ? 'Wpisz liczbę' : 'Wpisz pełną własną wartość'}
          helperText={d.typ_danych === 'NUMBER'
            ? 'Możesz wpisać dowolną wartość liczbową.'
            : 'Możesz wpisać dowolny tekst, np. Asus, 1200x1200, USB-C + HDMI albo pełny model.'}
        />}

        <Typography variant="caption" color={valueText ? 'success.main' : 'text.secondary'}>
          {valueText
            ? `Ustawiona wartość: ${valueText}`
            : trybWlasny
              ? 'Wpisz własną wartość w polu powyżej.'
              : 'Wybierz wartość z listy albo wybierz „Inna wartość”.'}
        </Typography>
      </Box>;
    }

    return <TextField
      key={d.id_parametru}
      required={!!d.wymagany}
      type={d.typ_danych === 'NUMBER' ? 'number' : d.typ_danych === 'DATE' ? 'date' : 'text'}
      label={`${d.nazwa}${d.jednostka ? ` (${d.jednostka})` : ''}`}
      InputLabelProps={d.typ_danych === 'DATE' ? { shrink: true } : undefined}
      value={value}
      onChange={e => setParametry(p => ({ ...p, [d.id_parametru]: e.target.value }))}
    />;
  };

  const kroki = [
    [1,'Informacje podstawowe'],
    [2,'Dane ewidencyjne'],
    [3,'Parametry techniczne'],
    [4,'Amortyzacja'],
    [5,'Podsumowanie']
  ];

  const producentNazwa = slowniki.producenci.find(x=>String(x.id_producenta)===String(form.id_producenta))?.nazwa || '—';
  const lokalizacjaNazwa = slowniki.lokalizacje.find(x=>String(x.id_lokalizacji)===String(form.id_lokalizacji))?.nazwa || '—';
  const pracownikNazwa = (() => {
    const x=slowniki.pracownicy.find(x=>String(x.id_pracownika)===String(form.id_pracownika));
    return x ? `${x.imie} ${x.nazwisko}` : '—';
  })();
  const serwisNazwa = slowniki.serwisy.find(x=>String(x.id_firmy_serwisowej)===String(form.id_firmy_serwisowej))?.nazwa || '—';

  const pokazBladKroku = (numerKroku, komunikat) => {
    setKrok(numerKroku);
    setBlad(komunikat);
    setBladDialogOpen(true);
    return false;
  };

  const walidujKrok = numerKroku => {
    setBlad('');

    if (numerKroku === 1) {
      if (!form.id_kategorii) return pokazBladKroku(1, 'Krok 1: wybierz kategorię urządzenia.');
      if (!form.model?.trim()) return pokazBladKroku(1, 'Krok 1: wpisz model urządzenia.');
      return true;
    }

    if (numerKroku === 2) {
      // Sprawdzenie kolejności dat
      
      if (form.data_zakupu && form.data_przyjecia && form.data_zakupu > form.data_przyjecia) {
        return pokazBladKroku(2, 'Krok 2: data zakupu nie może być późniejsza niż data przyjęcia.');
      }
      if (form.data_gwarancji_do && form.data_zakupu && form.data_gwarancji_do < form.data_zakupu) {
        return pokazBladKroku(2, 'Krok 2: data końca gwarancji nie może być wcześniejsza niż data zakupu.');
      }
      return true;
    }

    if (numerKroku === 3) {
      for (const d of definicje) {
        const v = wartoscParametruDoZapisu(d);
        if (d.wymagany && (v === '' || v === undefined || v === null)) {
          return pokazBladKroku(3, `Krok 3: uzupełnij wymagany parametr „${d.nazwa}”.`);
        }
        if (d.typ_danych === 'NUMBER' && v !== '' && v !== undefined && !Number.isFinite(Number(v))) {
          return pokazBladKroku(3, `Krok 3: parametr „${d.nazwa}” musi być liczbą.`);
        }
      }
      return true;
    }

    if (numerKroku === 4 && amortyzacja?.enabled) {
      if (!amortyzacja.id_metody) return pokazBladKroku(4, 'Krok 4: wybierz metodę amortyzacji.');
      if (amortyzacja.wartosc_poczatkowa === '' || amortyzacja.wartosc_poczatkowa === null || amortyzacja.wartosc_poczatkowa === undefined) {
        return pokazBladKroku(4, 'Krok 4: wpisz wartość początkową.');
      }
      if (!Number.isFinite(Number(amortyzacja.wartosc_poczatkowa)) || Number(amortyzacja.wartosc_poczatkowa) <= 0) {
        return pokazBladKroku(4, 'Krok 4: wartość początkowa musi być liczbą większą od 0.');
      }
      if (!(amortyzacja.data_wprowadzenia || amortyzacja.data_rozpoczecia)) return pokazBladKroku(4, 'Krok 4: wybierz datę wprowadzenia do ewidencji amortyzacji.');
      if (amortyzacja.stawka_roczna_proc !== '' && amortyzacja.stawka_roczna_proc !== null && amortyzacja.stawka_roczna_proc !== undefined) {
        const stawka=Number(amortyzacja.stawka_roczna_proc);
        if (!Number.isFinite(stawka) || stawka < 0 || stawka > 100) {
          return pokazBladKroku(4, 'Krok 4: stawka roczna musi mieścić się w zakresie 0–100%.');
        }
      }
      return true;
    }

    return true;
  };

  const przejdzDoKroku = docelowy => {
    if (docelowy <= krok) {
      setBlad('');
      setKrok(docelowy);
      return;
    }

    for (let n=krok; n<docelowy; n+=1) {
      if (!walidujKrok(n)) return;
    }
    setBlad('');
    setKrok(docelowy);
  };

  const dalej = () => {
    if (!walidujKrok(krok)) return;

    // Przejście do podsumowania
    
    if (krok === 4) {
      setBlad('');
      setKrok(5);
      return;
    }

    setKrok(k => Math.min(5,k+1));
  };

  const wstecz = () => {
    setBlad('');
    setKrok(k => Math.max(1,k-1));
  };

  const krokSpelniony = n => {
    if (n === 1) return !!form.id_kategorii && !!form.model?.trim();
    if (n === 2) {
      if (form.data_zakupu && form.data_przyjecia && form.data_zakupu > form.data_przyjecia) return false;
      if (form.data_gwarancji_do && form.data_zakupu && form.data_gwarancji_do < form.data_zakupu) return false;
      return true;
    }
    if (n === 3) return definicje.every(d => {
      if (!d.wymagany) return true;
      const v=wartoscParametruDoZapisu(d);
      return v !== '' && v !== undefined && v !== null;
    });
    if (n === 4) {
      if (!amortyzacja?.enabled) return true;
      return !!amortyzacja.id_metody &&
        Number(amortyzacja.wartosc_poczatkowa) > 0 &&
        !!(amortyzacja.data_wprowadzenia || amortyzacja.data_rozpoczecia);
    }
    return n === 5;
  };

  const najwyzszyDostepnyKrok = (() => {
    let max=1;
    for (let n=1;n<=4;n+=1) {
      if (!krokSpelniony(n)) break;
      max=n+1;
    }
    return Math.min(5,max);
  })();

  const StepHeader = () => <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'repeat(5,1fr)'},gap:1,mb:3}}>
    {kroki.map(([n,l])=>{
      const aktywny=krok===n;
      const zakonczony=n<krok && krokSpelniony(n);
      const dostepny=n<=najwyzszyDostepnyKrok || n<=krok;

      return <Box key={n}
        onClick={()=>przejdzDoKroku(n)}
        title={dostepny ? l : 'Uzupełnij wcześniejsze kroki'}
        sx={{
          p:1.2,borderRadius:2,
          cursor:dostepny ? 'pointer' : 'not-allowed',
          opacity:dostepny ? 1 : .55,
          border:`1px solid ${aktywny ? '#2364d8' : zakonczony ? '#b8dfc4' : '#e4eaf2'}`,
          bgcolor:aktywny ? '#edf4ff' : zakonczony ? '#f1faf4' : '#fff'
        }}>
        <Box sx={{display:'flex',alignItems:'center',gap:1}}>
          <Box sx={{
            width:26,height:26,borderRadius:'50%',display:'grid',placeItems:'center',
            bgcolor:aktywny ? '#2364d8' : zakonczony ? '#2f9e56' : '#eef2f7',
            color:(aktywny || zakonczony) ? '#fff' : '#64748b',
            fontWeight:800,fontSize:12
          }}>{zakonczony ? '✓' : n}</Box>
          <Box>
            <Typography variant="body2" fontWeight={aktywny ? 850 : 650}>{l}</Typography>
            {!dostepny && <Typography variant="caption" color="text.secondary">zablokowany</Typography>}
          </Box>
        </Box>
      </Box>;
    })}
  </Box>;

  const SectionTitle = ({title,subtitle}) => <Box sx={{mb:2}}>
    <Typography variant="h6" fontWeight={800}>{title}</Typography>
    {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
  </Box>;

  // Pole notatki
  
  const noteBox = ({checked,onChange,label,value,field,helper}) => <Box sx={{mt:2,p:2,bgcolor:'#fffaf0',border:'1px solid #f2dfb7',borderRadius:2}}>
    <FormControlLabel control={<Switch checked={checked} onChange={onChange}/>} label={label}/>
    {checked && <TextField fullWidth multiline minRows={3} label={label} value={value || ''} onChange={zmien(field)} helperText={helper}/>}
  </Box>;

  return <Paper component="div" onKeyDown={enterDoKolejnegoPola}
    sx={{p:{xs:2,md:3},borderRadius:3,border:'1px solid #e6edf5',boxShadow:'0 10px 28px rgba(15,47,89,.06)'}}>
    {blad && <Alert severity="error" sx={{mb:2}}><b>Nie można zapisać:</b> {blad}</Alert>}
    <Dialog open={bladDialogOpen} onClose={()=>setBladDialogOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Błąd danych</DialogTitle>
      <DialogContent><Alert severity="error">{blad || 'Sprawdź wprowadzone dane.'}</Alert></DialogContent>
      <DialogActions><Button onClick={()=>setBladDialogOpen(false)} variant="contained">Popraw dane</Button></DialogActions>
    </Dialog>

    <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',mb:3,gap:2,flexWrap:'wrap'}}>
      <Box>
        <Typography variant="h5" fontWeight={800}>{tryb==='edytuj' ? 'Edytuj środek trwały' : 'Dodaj środek trwały'}</Typography>
        <Typography variant="body2" color="text.secondary">
          {tryb==='edytuj' ? 'Zmień dane środka bez ingerencji w jego historię.' : 'Wprowadź dane nowego środka trwałego krok po kroku.'}
        </Typography>
      </Box>
      <Box sx={{display:'flex',gap:1}}>
        <Button type="button" variant="outlined" onClick={onAnuluj}>Anuluj</Button>
        {krok===5 && <Button type="button" onClick={submit} variant="contained" disabled={zapisuje}>
          {zapisuje ? 'Zapisywanie...' : tryb==='edytuj' ? 'Zapisz zmiany' : 'Zapisz środek trwały'}
        </Button>}
      </Box>
    </Box>

    <StepHeader/>

    {krok===1 && <Box>
      <SectionTitle title="Informacje podstawowe" subtitle="Podstawowe dane identyfikujące środek oraz jego bieżące przypisanie."/>
      <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'repeat(3,minmax(0,1fr))'},gap:2}}>
        <TextField select required label="Kategoria urządzenia" value={form.id_kategorii} onChange={zmienKategorie}>
          <MenuItem value="">Wybierz kategorię</MenuItem>
          {slowniki.kategorie.map(x=><MenuItem key={x.id_kategorii} value={x.id_kategorii}>{x.nazwa}</MenuItem>)}
        </TextField>
        <TextField select label="Producent" value={form.id_producenta} onChange={zmien('id_producenta')}>
          <MenuItem value="">Brak / inny</MenuItem>
          {slowniki.producenci.map(x=><MenuItem key={x.id_producenta} value={x.id_producenta}>{x.nazwa}</MenuItem>)}
        </TextField>
        <TextField required label="Model" value={form.model || ''} onChange={zmien('model')}/>
        <TextField label="Numer INW" value={form.numer_inw || ''} onChange={zmien('numer_inw')}/>
        <TextField label="Numer seryjny" value={form.numer_seryjny || ''} onChange={zmien('numer_seryjny')}/>
        <TextField label="Numer unikatowy"
          value={tryb==='dodaj' ? 'Nadawany automatycznie' : (form.numer_unikatowy || '')}
          InputProps={{readOnly:true}}/>
        <TextField select label="Lokalizacja" value={form.id_lokalizacji} onChange={zmien('id_lokalizacji')}>
          <MenuItem value="">Brak</MenuItem>{slowniki.lokalizacje.map(x=><MenuItem key={x.id_lokalizacji} value={x.id_lokalizacji}>{x.nazwa}</MenuItem>)}
        </TextField>
        <TextField select label="Użytkownik" value={form.id_pracownika} onChange={zmien('id_pracownika')}>
          <MenuItem value="">Brak przypisania</MenuItem>{slowniki.pracownicy.map(x=><MenuItem key={x.id_pracownika} value={x.id_pracownika}>{x.imie} {x.nazwisko}</MenuItem>)}
        </TextField>
        <TextField select label="Firma serwisowa" value={form.id_firmy_serwisowej} onChange={zmien('id_firmy_serwisowej')}>
          <MenuItem value="">Brak przypisania</MenuItem>{slowniki.serwisy.map(x=><MenuItem key={x.id_firmy_serwisowej} value={x.id_firmy_serwisowej}>{x.nazwa}</MenuItem>)}
        </TextField>
        <TextField select label="Status" value={form.status} onChange={zmien('status')}>
          {STATUSY.map(([v,l])=><MenuItem key={v} value={v}>{l}</MenuItem>)}
        </TextField>
      </Box>
      {noteBox({checked:pokazNotatkeInformacje,onChange:e=>setPokazNotatkeInformacje(e.target.checked),label:'Notatka - informacje ogólne',value:form.komentarz,field:'komentarz',helper:'Opcjonalne informacje ogólne dotyczące tego środka.'})}
    </Box>}

    {krok===2 && <Box>
      <SectionTitle title="Dane ewidencyjne" subtitle="Daty oraz informacje związane z przyjęciem, zakupem i gwarancją."/>
      <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'repeat(2,minmax(0,1fr))'},gap:2}}>
        {[
          ['data_produkcji','Data produkcji'],['data_zakupu','Data zakupu'],
          ['data_przyjecia','Data przyjęcia'],['data_gwarancji_do','Gwarancja do']
        ].map(([p,l])=><TextField key={p} type="date" label={l} InputLabelProps={{shrink:true}} value={form[p]||''} onChange={zmien(p)}/>)}
        <TextField label="Numer zamówienia" value={form.numer_zamowienia || ''} onChange={zmien('numer_zamowienia')}/>
      </Box>
      {noteBox({checked:pokazNotatkeEwidencja,onChange:e=>setPokazNotatkeEwidencja(e.target.checked),label:'Notatka - dane ewidencyjne',value:form.notatka_ewidencja,field:'notatka_ewidencja',helper:'Np. informacje o dokumentacji, zakupie, przyjęciu lub gwarancji.'})}
    </Box>}

    {krok===3 && <Box>
      <SectionTitle title={`Parametry techniczne${wybranaKategoria?.nazwa ? ` - ${wybranaKategoria.nazwa}` : ''}`}
        subtitle="Specyfikacja techniczna jest dopasowana do wybranej kategorii. W każdej liście możesz użyć własnej wartości."/>
      {!form.id_kategorii && <Alert severity="info">Najpierw wybierz kategorię w kroku 1.</Alert>}
      {!!form.id_kategorii && !definicje.length && <Alert severity="info">Dla tej kategorii nie zdefiniowano parametrów technicznych.</Alert>}
      {!!definicje.length && <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'repeat(2,minmax(0,1fr))'},gap:2}}>
        {definicje.map(renderParametr)}
      </Box>}
      {noteBox({checked:pokazNotatkeParametry,onChange:e=>setPokazNotatkeParametry(e.target.checked),label:'Notatka - parametry techniczne',value:form.notatka_parametry,field:'notatka_parametry',helper:'Dodatkowy parametr lub informacja techniczna, dla której nie ma osobnego pola.'})}
    </Box>}

    {krok===4 && <Box>
      <SectionTitle title="Amortyzacja" subtitle="Ustaw podstawowe dane amortyzacji. Później plan będzie można dokładnie przeliczyć i edytować w module Amortyzacja."/>
      <Paper variant="outlined" sx={{p:{xs:1.5,sm:2},borderRadius:2.5,borderColor:'#dbe7f6',bgcolor:'#fbfdff'}}>
        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:{xs:'flex-start',sm:'center'},gap:1.5,flexDirection:{xs:'column',sm:'row'}}}>
          <Box>
            <Typography fontWeight={900}>Czy środek podlega amortyzacji?</Typography>
            <Typography variant="body2" color="text.secondary">Włączenie tej opcji pozwoli ustawić metodę, wartość oraz stawkę początkową.</Typography>
          </Box>
          <FormControlLabel sx={{m:0}} control={<Switch checked={!!amortyzacja?.enabled}
            onChange={e=>setAmortyzacja(a=>({...a,enabled:e.target.checked,stawka_roczna_proc:e.target.checked && (a.stawka_roczna_proc==='' || a.stawka_roczna_proc==null) ? sugerowanaStawkaAmortyzacji : a.stawka_roczna_proc,data_wprowadzenia:e.target.checked && !(a.data_wprowadzenia||a.data_rozpoczecia) ? wyliczDateWprowadzeniaAmortyzacji() : (a.data_wprowadzenia||a.data_rozpoczecia)}))}/>} label={amortyzacja?.enabled?'Tak':'Nie'}/>
        </Box>

        {amortyzacja?.enabled && <>
          <Alert severity="info" sx={{mt:2}}>Dla środków klasyfikowanych w aplikacji jako <b>KŚT 491</b> system sugeruje podstawową stawkę <b>30%</b>. Księgowa będzie mogła później zweryfikować i zmienić ją w module Amortyzacja.</Alert>

          <Typography fontWeight={900} sx={{mt:2.2,mb:1}}>Wybierz metodę amortyzacji</Typography>
          <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'repeat(3,minmax(0,1fr))'},gap:1.2}}>
            {metodyAmortyzacji.map(x=>{const info=opisMetodyAmortyzacji(x.nazwa);const aktywna=String(amortyzacja.id_metody)===String(x.id_metody);return <Paper key={x.id_metody} variant="outlined" onClick={()=>setAmortyzacja(a=>({...a,id_metody:x.id_metody,stawka_roczna_proc:String(x.nazwa||'').toLowerCase().includes('jednoraz')?'':(a.stawka_roczna_proc===''||a.stawka_roczna_proc==null?sugerowanaStawkaAmortyzacji:a.stawka_roczna_proc)}))} sx={{p:1.6,cursor:'pointer',borderWidth:aktywna?2:1,borderColor:aktywna?'#2364d8':'#e3eaf3',bgcolor:aktywna?'#f3f8ff':'#fff',transition:'all .15s ease','&:hover':{borderColor:'#7da7e8',bgcolor:'#f8fbff'}}}>
              <Box sx={{display:'flex',justifyContent:'space-between',gap:1,alignItems:'center'}}><Typography fontWeight={900}>{x.nazwa}</Typography>{aktywna&&<Typography variant="caption" fontWeight={900} sx={{color:'#2364d8'}}>WYBRANA</Typography>}</Box>
              <Typography variant="body2" color="text.secondary" sx={{mt:.6}}>{info.opis}</Typography>
              {info.wzor&&<Typography variant="caption" sx={{display:'block',mt:1,fontWeight:750,color:'#526173'}}>{info.wzor}</Typography>}
            </Paper>;})}
          </Box>

          <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',md:'repeat(2,minmax(0,1fr))'},gap:2,mt:2}}>
            <TextField required type="number" label="Wartość początkowa" value={amortyzacja.wartosc_poczatkowa ?? ''} onChange={e=>setAmortyzacja(a=>({...a,wartosc_poczatkowa:e.target.value}))} helperText="Wartość, od której będą naliczane odpisy."/>
            {!metodaJednorazowa&&<TextField type="number" label="Stawka roczna (%)" value={amortyzacja.stawka_roczna_proc ?? ''} onChange={e=>setAmortyzacja(a=>({...a,stawka_roczna_proc:e.target.value}))} helperText={`Sugerowana stawka dla KŚT 491: ${sugerowanaStawkaAmortyzacji}%`}/>} 
            <TextField required type="date" label="Data wprowadzenia do ewidencji amortyzacji" InputLabelProps={{shrink:true}}
              inputProps={{min:'1900-01-01',max:'2099-12-31'}}
              value={dataInput(amortyzacja.data_wprowadzenia || amortyzacja.data_rozpoczecia)}
              onChange={e=>setAmortyzacja(a=>({...a,data_wprowadzenia:e.target.value,data_rozpoczecia:null}))}
              helperText={sugerowanyPierwszyOdpisAmortyzacji
                ? `Sugerowany pierwszy odpis amortyzacyjny: ${dataPL(sugerowanyPierwszyOdpisAmortyzacji)}. To tylko sugestia — możesz wpisać także wcześniejszą datę historyczną.`
                : 'Możesz również wprowadzić datę historyczną.'}/>
            <Box sx={{p:1.5,border:'1px solid #e3eaf3',borderRadius:2,bgcolor:'#f8fafc'}}>
              <Typography variant="caption" color="text.secondary">Wybrana metoda</Typography>
              <Typography fontWeight={900}>{wybranaMetodaAmortyzacji?.nazwa || 'Nie wybrano'}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{mt:.4}}>{metodaDegresywna?'Dokładny współczynnik i harmonogram ustawisz w module Amortyzacja.':metodaJednorazowa?'Możliwość zastosowania odpisu jednorazowego powinna zostać zweryfikowana przez księgową.':'Pełny harmonogram miesiąc po miesiącu utworzysz w module Amortyzacja.'}</Typography>
            </Box>
          </Box>
        </>}
      </Paper>
    </Box>}

    {krok===5 && <Box>
      <SectionTitle title="Podsumowanie" subtitle="Sprawdź dane w podziale na sekcje. Jeśli coś wymaga zmiany, kliknij „Edytuj” przy odpowiedniej karcie."/>

      <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',lg:'1fr 1fr'},gap:2}}>
        <Paper variant="outlined" sx={{p:2,borderRadius:2.5,borderColor:'#dbe7f6'}}>
          <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mb:1.2}}>
            <Box>
              <Typography fontWeight={900}>1. Informacje podstawowe</Typography>
              <Typography variant="caption" color="text.secondary">Identyfikacja i przypisanie środka</Typography>
            </Box>
            <Button size="small" onClick={()=>setKrok(1)}>Edytuj</Button>
          </Box>

          {[
            ['Kategoria',wybranaKategoria?.nazwa || '—'],
            ['Producent',producentNazwa],
            ['Model',form.model || '—'],
            ['Numer INW',form.numer_inw || '—'],
            ['Numer seryjny',form.numer_seryjny || '—'],
            ['Status',form.status || '—'],
            ['Lokalizacja',lokalizacjaNazwa],
            ['Użytkownik',pracownikNazwa],
            ['Firma serwisowa',serwisNazwa]
          ].map(([l,v])=><Box key={l} sx={{display:'grid',gridTemplateColumns:'130px 1fr',gap:2,py:.55,borderBottom:'1px solid #f1f4f8'}}>
            <Typography variant="body2" color="text.secondary">{l}</Typography>
            <Typography variant="body2" fontWeight={750} sx={{wordBreak:'break-word'}}>{v}</Typography>
          </Box>)}

          {pokazNotatkeInformacje && form.komentarz && <Box sx={{mt:1.4,p:1.4,bgcolor:'#fffaf0',borderRadius:1.5}}>
            <Typography variant="caption" color="text.secondary">Notatka ogólna</Typography>
            <Typography variant="body2" sx={{whiteSpace:'pre-wrap'}}>{form.komentarz}</Typography>
          </Box>}
        </Paper>

        <Paper variant="outlined" sx={{p:2,borderRadius:2.5,borderColor:'#dbe7f6'}}>
          <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mb:1.2}}>
            <Box>
              <Typography fontWeight={900}>2. Dane ewidencyjne</Typography>
              <Typography variant="caption" color="text.secondary">Daty i dane dokumentacyjne</Typography>
            </Box>
            <Button size="small" onClick={()=>setKrok(2)}>Edytuj</Button>
          </Box>

          {[
            ['Data produkcji',form.data_produkcji || '—'],
            ['Data zakupu',form.data_zakupu || '—'],
            ['Data przyjęcia',form.data_przyjecia || '—'],
            ['Gwarancja do',form.data_gwarancji_do || '—'],
            ['Numer zamówienia',form.numer_zamowienia || '—']
          ].map(([l,v])=><Box key={l} sx={{display:'grid',gridTemplateColumns:'130px 1fr',gap:2,py:.55,borderBottom:'1px solid #f1f4f8'}}>
            <Typography variant="body2" color="text.secondary">{l}</Typography>
            <Typography variant="body2" fontWeight={750}>{v}</Typography>
          </Box>)}

          {pokazNotatkeEwidencja && form.notatka_ewidencja && <Box sx={{mt:1.4,p:1.4,bgcolor:'#fffaf0',borderRadius:1.5}}>
            <Typography variant="caption" color="text.secondary">Notatka ewidencyjna</Typography>
            <Typography variant="body2" sx={{whiteSpace:'pre-wrap'}}>{form.notatka_ewidencja}</Typography>
          </Box>}
        </Paper>

        <Paper variant="outlined" sx={{p:2,borderRadius:2.5,borderColor:'#dbe7f6'}}>
          <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mb:1.2}}>
            <Box>
              <Typography fontWeight={900}>3. Parametry techniczne</Typography>
              <Typography variant="caption" color="text.secondary">{wybranaKategoria?.nazwa || 'Wybrana kategoria'}</Typography>
            </Box>
            <Button size="small" onClick={()=>setKrok(3)}>Edytuj</Button>
          </Box>

          {definicje.length ? <Box sx={{display:'grid',gridTemplateColumns:{xs:'1fr',sm:'1fr 1fr'},gap:1}}>
            {definicje.map(d=>{
              const v=wartoscParametruDoZapisu(d);
              return <Box key={d.id_parametru} sx={{p:1.2,bgcolor:'#f8fafc',borderRadius:1.5}}>
                <Typography variant="caption" color="text.secondary">{d.nazwa}{d.jednostka ? ` (${d.jednostka})` : ''}</Typography>
                <Typography variant="body2" fontWeight={800}>{v === '' || v === undefined ? '—' : String(v)}</Typography>
              </Box>;
            })}
          </Box> : <Typography variant="body2" color="text.secondary">Dla tej kategorii nie zdefiniowano parametrów.</Typography>}

          {pokazNotatkeParametry && form.notatka_parametry && <Box sx={{mt:1.4,p:1.4,bgcolor:'#f5f0ff',borderRadius:1.5}}>
            <Typography variant="caption" color="text.secondary">Notatka techniczna</Typography>
            <Typography variant="body2" sx={{whiteSpace:'pre-wrap'}}>{form.notatka_parametry}</Typography>
          </Box>}
        </Paper>

        <Paper variant="outlined" sx={{p:2,borderRadius:2.5,borderColor:'#dbe7f6'}}>
          <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mb:1.2}}>
            <Box>
              <Typography fontWeight={900}>4. Amortyzacja</Typography>
              <Typography variant="caption" color="text.secondary">Sekcja opcjonalna</Typography>
            </Box>
            <Button size="small" onClick={()=>setKrok(4)}>Edytuj</Button>
          </Box>

          {!amortyzacja?.enabled ? <Box sx={{p:1.5,bgcolor:'#f8fafc',borderRadius:1.5}}>
            <Typography variant="body2" color="text.secondary">Amortyzacja nie została włączona dla tego środka.</Typography>
          </Box> : <>
            {[
              ['Metoda',slowniki.metody.find(x=>String(x.id_metody)===String(amortyzacja.id_metody))?.nazwa || '—'],
              ['Wartość początkowa',`${Number(amortyzacja.wartosc_poczatkowa||0).toLocaleString('pl-PL',{minimumFractionDigits:2,maximumFractionDigits:2})} zł`],
              ['Stawka roczna',amortyzacja.stawka_roczna_proc === '' || amortyzacja.stawka_roczna_proc === null || amortyzacja.stawka_roczna_proc === undefined ? '—' : `${amortyzacja.stawka_roczna_proc}%`],
              ['Data wprowadzenia',dataInput(amortyzacja.data_wprowadzenia || amortyzacja.data_rozpoczecia) || '—']
            ].map(([l,v])=><Box key={l} sx={{display:'grid',gridTemplateColumns:'140px 1fr',gap:2,py:.55,borderBottom:'1px solid #f1f4f8'}}>
              <Typography variant="body2" color="text.secondary">{l}</Typography>
              <Typography variant="body2" fontWeight={750}>{v}</Typography>
            </Box>)}
          </>}
        </Paper>
      </Box>

    </Box>}

    <Box sx={{mt:4,pt:2,borderTop:'1px solid #edf1f6',display:'flex',justifyContent:'space-between',gap:1}}>
      <Button type="button" variant="outlined" disabled={krok===1} onClick={wstecz}>Wstecz</Button>
      {krok<5
        ? <Button type="button" variant="contained" onClick={dalej}>{krok===4 ? 'Przejdź do podsumowania' : 'Dalej'}</Button>
        : <Button type="button" onClick={submit} variant="contained" disabled={zapisuje}>{zapisuje ? 'Zapisywanie...' : tryb==='edytuj' ? 'Zapisz zmiany' : 'Zapisz środek trwały'}</Button>}
    </Box>
  </Paper>;
}
